import type { TypographyProps } from '@elfsight/widget-ui';
import type { ExtendedAudioItem } from '../../../sources';
import { Author as CommonAuthor } from '../Author';

interface AuthorProps {
  textStyle: TypographyProps['textStyle'];
  disableTicker: boolean;
  track?: ExtendedAudioItem;
}

export function Author({ textStyle, track, disableTicker }: AuthorProps) {
  const { author, hasAuthor } = track ?? {};

  if (!hasAuthor) {
    return null;
  }

  return (
    <CommonAuthor textStyle={textStyle} disableTicker={disableTicker}>
      {author}
    </CommonAuthor>
  );
}
